export default function estaNoContextoHome(caminhoURL: string) {
  return (
    caminhoURL === '/' ||
    caminhoURL.startsWith('/ficha') ||
    caminhoURL === '/recomendados' ||
    caminhoURL.startsWith('/assinatura') ||
    caminhoURL.startsWith('/noticias') ||
    caminhoURL.startsWith('/criticas') ||
    ['ajuda', 'plano', 'produto', 'pagamento-cartao', 'minha-conta'].some(
      (palavra) => caminhoURL.includes(palavra),
    )
  );
}
